import React from "react";
import { ReactComponent as Dashboard } from "../../../assets/Icons/dashboard.svg?react";
import { ReactComponent as Logout } from "../../../assets/Icons/logout.svg?react";
import { ReactComponent as Settings } from "../../../assets/Icons/settings.svg?react";
import { ReactComponent as Permission } from "../../../assets/Icons/permission.svg?react";
import { ReactComponent as People } from "../../../assets/Icons/people.svg?react";
import { ReactComponent as Branch } from "../../../assets/Icons/Branch.svg?react";
import { ReactComponent as Course } from "../../../assets/Icons/course.svg?react";
import { ReactComponent as Courselist } from "../../../assets/Icons/courselist.svg?react";
import { ReactComponent as Group } from "../../../assets/Icons/group.svg?react";
import { ReactComponent as Reports } from "../../../assets/Icons/reports.svg?react";
import { ReactComponent as CourseTasks } from "../../../assets/Icons/coursetask.svg?react";
import { ReactComponent as ActivityLog } from "../../../assets/Icons/activitylog.svg?react";
import { ReactComponent as Account } from "../../../assets/Icons/account.svg?react";
import { ReactComponent as Category } from "../../../assets/Icons/category.svg?react";
import {
  SettingOutlined,
  BranchesOutlined,
  TrophyOutlined,
  VideoCameraOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
// import Diversity3Icon from '@mui/icons-material/Diversity3';

const styleIcon = {
  height: "20px",
  width: "20px",
  marginRight: "5px",
};

const iconTypes = {
  dashboard: Dashboard,
  settings: Settings,
  logout: Logout,
  permission: Permission,
  people: People,
  appStore: Settings,
  branch: Branch,
  course: Course,
  courselist: Courselist,
  group: Group,
  report: Reports,
  coursetask: CourseTasks,
  activitylog: ActivityLog,
  account: Account,
  category: Category,
  scoring: TrophyOutlined,
  conference: VideoCameraOutlined,
  calendar: CalendarOutlined,
};

const Icon = ({ name }) => {
  return iconTypes[name]
    ? React.createElement(iconTypes[name], { style: styleIcon })
    : null;
};

export default Icon;
